import React, { Component } from 'react'
import Container from '../../components/layout/container.component'
import Title from '../../components/typography/title.component'
import { StyledRegulation } from './rebooking.styles'

class RebookingPage extends Component {
	render() {
		return (
			<Container style={{ paddingBottom: '5rem' }}>
				<Title>
					<span className="bold">
						Remarcação e Transferência de Passagens
					</span>
				</Title>
				<StyledRegulation>
					<br></br>
					<div>
						<h3>
							<strong>Caso deseje remarcar ou transferir sua passagem, siga as
							orientações abaixo:</strong>
						</h3>
						<p>
							Atenção: Por motivos de segurança de dados e integridade operacional, 
							o cancelamento e a remarcação de bilhete de passagem devem ser realizados 
							exclusivamente pelo titular do cadastro no site da Planalto Transportes e Muviflex.
							É responsabilidade do titular enviar o bilhete de passagem ao passageiro, 
							caso este não seja o próprio titular. Bilhetes adquiridos em ambientes digitais 
							devem ser cancelados exclusivamente no mesmo local onde foram comprados. 
							Informamos ainda que as rodoviárias do Rio Grande do Sul não emitem segunda via do bilhete de passagem.

						</p>
						<p>
							Com base nas legislações vigentes, apresentamos um resumo
							das etapas para a solicitação de remarcações ou transferências 
							disponíveis exclusivamente para passagens da Planalto Transportes 
							na operação de transporte rodoviário interestadual.
						</p>
						<ol>
							<li>
								<strong>Remarcação de Passagens Interestadual:</strong>
								<ul>
									<li>
										Para remarcar sua passagem interestadual, siga os passos a seguir:
										<ul>
											<li>
												Acesse seu cadastro no site da Planalto Transportes ou do Muviflex.
											</li>
											<li>
												Vá até o menu {' '}
												<a href="https://www.muviflex.com.br/cliente/minhas-compras">
												Minhas compras
												</a>
											</li>
											<li>
												Localize o pedido e clique nele.
											</li>
											<li>
												Selecione a opção de Remarcação.
											</li>
											<li>
												Em seguida, você será direcionado à busca por novos horários e, 
												por fim, poderá inserir os dados necessários para confirmar a nova viagem.
											</li>
										</ul>
									</li>
									<li>
										Caso você não tenha cadastro será necessário a realização do mesmo. 
										Para tanto, basta você acessar o site Muviflex e clique em "Entrar". 
										Na tela de login, clique em "Esqueci a senha" e informe o e-mail 
										utilizado na compra. Redefina a senha via e-mail recebido e efetue login 
										no site. Após isso, efetue os passos do item anterior.
									</li>
									<li>
										A remarcação de bilhetes de passagens adquiridos no site da 
										Planalto Transportes e no Muviflex será possível até 03 horas antes 
										do início da viagem, por uma (01) única vez.
									</li>
									<li>
										A partir de 3 (três) horas antes do horário do início da viagem até o 
										término de validade do bilhete de passagem a remarcação é possível no 
										guichê da rodoviário da origem da viagem ou mediante contato com o 
										SAC da Planalto Transportes, com pagamento de multa. 
										Contatar telefone (55) 4020-7488.
									</li>
								</ul>
							</li>
							<li>
								<strong>Multa e Pagamento de diferença de valor da tarifa de passagens Interestaduais:</strong>
								<ul>
									<li>
										A remarcação da passagem interestadual efetuada com até 3 horas de antecedência 
										ao horário previsto para embarque será isenta de multa.
									</li>
									<li>
										Conforme estabelecido na Resolução nº 5.974/2022, caso a solicitação de remarcação
										do Bilhete de Passagem, prevista no inciso VIII, seja realizada a partir 
										de 3 (três) horas antes do início da viagem, a transportadora poderá, 
										a seu critério, cobrar uma taxa de remarcação de até 20% (vinte por cento) 
										do valor da tarifa. Este procedimento poderá ser realizado para qualquer data 
										disponível dentro do prazo de 1 (um) ano a partir da data original da compra.
									</li>
									<li>
										No caso de remarcação do bilhete, o passageiro pode optar por serviço em 
										veículo de categoria diversa do originalmente contratado, arcando com as 
										diferenças dos valores de tarifa, no caso de serviço em veículo de categoria 
										superior, ou tendo direito à restituição das diferenças de preço, 
										no caso de serviço em veículo de categoria inferior.
									</li>
								</ul>
							</li>
							<li>
								<strong>Remarcação de Passagem Intermunicipal:</strong>
								<ul>
									<li>
										A remarcação de bilhetes de passagens para viagens intermunicipais
										deve ser feita até três horas antes do início da viagem.
									</li>
									<li>
										Após o prazo estabelecido, não será possível realizar remarcação 
										ou cancelamento da passagem, conforme Lei Estadual n° 14834/2016.
									</li>
									<li>
										Em caso de cancelamento realizado dentro do prazo, o passageiro 
										terá o direito ao reembolso do valor pago, com a dedução da taxa de serviço,
										referente à compra realizada em ambiente digital,
										conforme item 6.1.4 do {' '} 
										<a href="https://www.muviflex.com.br/regulamento">
										Regulamento do Muviflex
										Além disso, em razão do cancelamento, será aplicada a multa de 
										5% prevista para Transportadora.
										</a>
									</li>
									<li>
										A remarcação da passagem intermunicipal adquirida por meio digital 
										deve ser realizada diretamente no site da Planalto Transportes ou 
										do Muviflex, seguindo os passos a seguir:
										<ul>
											<li>
												Acesse seu cadastro no site da Planalto Transportes ou do Muviflex.
											</li>
											<li>
												Vá até o menu {' '}
												<a href="https://www.muviflex.com.br/cliente/minhas-compras">
												Minhas compras
												</a>
											</li>
											<li>
												Localize o pedido e clique nele.
											</li>
											<li>
												Selecione a opção de Remarcação.
											</li>
											<li>
												Em seguida, você será direcionado à busca por novos horários e, 
												por fim, poderá inserir os dados necessários para confirmar a nova viagem.
											</li>
										</ul>
									</li>
									<li>
										Caso você não tenha cadastro será necessário a 
										realização do mesmo. Para tanto, basta você acessar o 
										site Muviflex e clique em "Entrar". Na tela de login, 
										clique em "Esqueci a senha" e informe o e-mail utilizado na compra. 
										Redefina a senha via e-mail recebido e efetue login no site. 
										Após isso, efetue os passos do item anterior.
									</li>
									<li>
										No caso de remarcação do bilhete, o passageiro 
										pode optar por serviço em veículo de categoria diversa 
										do originalmente contratado, arcando com as diferenças dos valores.
									</li>
								</ul>
							</li>
							<li>
								<strong>Transferência de Passagens Interestaduais:</strong>
								<ul>
									<li>
										A transferência de bilhete transferível 
										a outro passageiro é um serviço exclusivo da operação interestadual.
									</li>
									<li>
										No Rio Grande do Sul não é possível a 
										transferência de bilhete transferível a outro passageiro.
									</li>
									<li>
										A transferência de passagens é uma funcionalidade que 
										permite alterar o nome e documento do passageiro, ou seja, 
										transferir a passagem para um outro viajante.
									</li>
									<li>
										A transferência de bilhete transferível a outro passageiro, 
										observado o prazo de validade, dar-se-á pela presença 
										do passageiro cedente ou por meio da apresentação de seu 
										documento de identidade original, munido dos bilhetes de 
										passagem e embarque, no guichê da rodoviário da origem da 
										viagem ou SAC da transportadora. 
									</li>
									<li>
										Não é possível a realização de 
										transferência no site da Planalto Transportes e Muviflex. 
									</li>

								</ul>
							</li>
							<li>
								<ul>
								<strong>Solicitação de Alteração, Correção e Eliminação de Dados Cadastrais:</strong>
									<li>
										Para garantir a segurança e a proteção de nossos clientes, 
										solicitamos que, ao fazer um pedido de alteração, correção 
										ou eliminação de dados cadastrais, você envie uma cópia legível 
										do seu documento de identidade (frente e verso), juntamente 
										com uma selfie segurando o documento ao lado do rosto. Esta 
										medida é necessária para confirmar que a solicitação está sendo 
										feita pelo próprio titular dos dados. Por favor, certifique-se de 
										que a foto do documento esteja legível para facilitar o processamento da solicitação.
									</li>
									<li>
										O requerimento expresso deve ser enviado para o e-mail:
										encarregadodedados@jmt.com.br ou faleconosco@muviflex.com.br
									</li>
									<li>
										Essas precauções são adotadas para proteger os dados pessoais 
										de nossos clientes e garantir que alterações, correções ou 
										exclusões solicitadas pelos titulares de dados sejam realizadas de 
										forma segura e legítima. Reservamo-nos o direito de solicitar informações 
										adicionais que julgarmos necessárias para cumprir essa finalidade com segurança e precisão.
									</li>
									<li>
										Caso haja qualquer dúvida sobre como tratamos seus dados pessoais acesse: {' '}
										<a href="https://www.muviflex.com.br/politica-de-privacidade">
										Política de Privacidade
										</a>
									</li>
								</ul>
							</li>
						</ol>
						<p>Agradecemos por escolher o Muviflex para suas viagens!</p>
					</div>
				</StyledRegulation>
			</Container>
		)
	}
}

export { RebookingPage as ModuleRootComponent }
